import React from 'react'
import Link from 'gatsby-link'

import { Text } from '../components/Layout'

const LinkStyle = ({ text, ...props }) => (
  <Text
    color="black"
    textDecoration="underline"
    textDecorationColor="orange"
    hover={{ color: 'orange' }}
    {...props}
  >
    {text}
  </Text>
)

const StyledLink = ({ to, text, external, ...props }) => {
  return external ? (
    <a href={to}>
      <LinkStyle text={text} {...props} />
    </a>
  ) : (
    <Link to={to}>
      <LinkStyle text={text} {...props} />
    </Link>
  )
}

export { LinkStyle, StyledLink }



// WEBPACK FOOTER //
// ./src/components/StyledLink.js